import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import { Select as SerendieSelect } from "@serendie/ui";
import "./Styles.scss";
import { components } from "../../Components";
import { Guid } from "@iconics/core";

export class Select extends BaseComponent<ISelectProps, ISelectState>
{
    private inputId = Guid.new().toString().toLowerCase();
    private inputElement: HTMLInputElement | null = null;
    public static requiredLabel = '*';

    private ref(inputElement: HTMLInputElement | null): void
    {
        this.inputElement = inputElement;
        const { ref } = this.props;

        if (typeof ref == 'function')
        {
            ref(inputElement);
        }
        else if (ref)
        {
            ref.current = inputElement;
        }
    }

    public componentDidMount(): void
    {
        this.updateRequiredLabel();
    }

    public componentDidUpdate(): void
    {
        this.updateRequiredLabel();
    }

    private updateRequiredLabel(): void
    {
        const requiredContainer = this.inputElement?.querySelector('label')?.querySelector('span');
        if (!requiredContainer)
        {
            return;
        }
        requiredContainer.innerText = this.props.requiredLabel ?? Select.requiredLabel;
    }

    private handleOpenChange(details: ISelectOpenChangeDetails): void
    {
        const popper = document.getElementById(`select:${this.inputId}:positioner`);
        if (popper && !popper.classList.contains('serendie-select__popper'))
        {
            popper.classList.add('serendie-select__popper');
        }
        this.props.onOpenChange?.(details);
    }

    public render(): JSX.Element
    {
        const SerendieSelectWithRef = SerendieSelect as React.FC<ISerendieProps>;

        return (
            <SerendieSelectWithRef
                id={this.inputId}
                {...this.props}
                ref={(e: HTMLInputElement | null) => this.ref(e)}
                className={`${this.props.className ?? ''} serendie-select`}
                onOpenChange={e => this.handleOpenChange(e)}
            />
        )
    }
}

export interface ISelectProps extends ISerendieProps
{
    requiredLabel?: string;
}

interface ISerendieProps extends Omit<React.ComponentProps<typeof SerendieSelect>, 'collection'>
{
    ref?: React.Ref<any>;
}

export interface ISelectState
{
}

export interface ISelectOpenChangeDetails
{
    open: boolean;
    value: string[];
}

export interface ISelectItem
{
    value: string;
    label: string;
}
